import {BrowserRouter, Routes, Route} from "react-router-dom";
import Dashboard from "./components/Dashboard.jsx";
import Landing from './components/auth/Landing.jsx';
import Profile from "./components/Profile.jsx";
import Alerts from "./components/Alerts.jsx";
import CurrentCloudAlerts from "./components/CurrentCloudAlerts.jsx"
import CloudAlerts from "./components/CloudAlerts.jsx"
import Reports from "./components/Reports.jsx";
import Settings from "./components/Settings.jsx";
import Users from "./components/Users.jsx";
import Demo from "./components/Demo.jsx";
import Community from "./components/Community.jsx";
import UnderConstruction from "./components/auth/UnderConstruction.jsx";
import Profiles from "./components/Profiles.jsx";
import Insights from "./components/Insights.jsx";
import Customers from "./components/Customers.jsx";
import AuditLogs from "./components/AuditLogs.jsx";
import 'react-material-symbols'
import Tasks from "./components/Tasks.jsx";
import Billing from "./components/Billing.jsx";
import HelpGuide from "./components/help/HelpGuide.jsx";
import {useEffect} from "react";
import AlertNotificationProvider from "./components/AlertNotificationProvider.jsx";
import WalkthroughGate from "./components/v2/WalkthroughGate.jsx";
import ServerOfflineBanner from "./components/v2/ServerOfflineBanner.jsx";
import {Hub} from 'aws-amplify/utils';
import { getSession } from "./services/session";

const App = () => {

    let dData;
    useEffect(() => {
        // Load Material Symbols font
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
        document.head.appendChild(link);

        // Listen for Amplify auth events (token refresh failure = session expired)
        const unsubscribe = Hub.listen('auth', ({payload}) => {
            if (payload.event === 'tokenRefresh_failure') {
                // Refresh token expired (user idle too long) — force re-login
                sessionStorage.clear();
                window.location.href = '/';
            }
        });

        return () => {
            unsubscribe();
        };
    }, []);

    if (import.meta.env.VITE_MAINTENANCE === "true"){
        if (window.location.pathname !== "/"){
            return window.location.href = "/";
        }else{
            return (
                <BrowserRouter>
                    <Routes>
                        <Route path={"/"} element={<UnderConstruction />} />
                    </Routes>
                </BrowserRouter>
            );
        }
    }
    else if (getSession() == null){
        if (window.location.pathname !== "/"){
            return window.location.href = "/";
        }else{
            return (
                <BrowserRouter>
                    <Routes>
                        <Route path={"/:dType"} element={<Landing />} />
                        <Route path={"/"} element={<Landing />} />
                    </Routes>
                </BrowserRouter>
            )
        }
    }else{
        dData = getSession();
        if (dData?.slauth === true && dData?.tKey != null && dData?.tKey !== "" && dData?.acnt != null){
            if (dData?.migrated){
                return (
                    <AlertNotificationProvider>
                        <BrowserRouter>
                            {/* Onsite-server-offline warning strip. Self-gating — renders
                                null unless a type-41 alert is live on a v2 session — and
                                mounted outside <Routes> so navigation never unmounts it.

                                It must stay ABOVE <Routes>: the banner is in normal flow
                                (position: sticky), so DOM order is what puts it over the
                                routed page instead of under it. Inside
                                AlertNotificationProvider so it reads the same subscription
                                the alerts pages do, with no fetch of its own. */}
                            <ServerOfflineBanner />
                            <Routes>
                                <Route path={"/"} element={<Landing />} />
                                <Route path={"/dash/null"} element={<Dashboard />} />
                                <Route path={"/dash/:dType"} element={<Dashboard />} />
                                <Route path={"/emergency/station"} element={<CloudAlerts fullscreen={true} />} />
                                <Route path={"/emergency"} element={<CloudAlerts />} />
                                <Route path={"/alerts/fullscreen/:dType"} element={<Alerts fullscreen={true} />} />
                                <Route path={"/alerts/:dType"} element={<Alerts />} />
                                <Route path={"/alerts"} element={<Alerts />} />
                                <Route path={"/reports/:dType"} element={<Reports />} />
                                <Route path={"/reports/:dType/:eType"} element={<Reports />} />
                                <Route path={"/settings/:dType"} element={<Settings />} />
                                <Route path={"/community/:dType"} element={<Community />} />
                                <Route path={"/community/:dType/:eType"} element={<Community />} />
                                <Route path={"/community/:dType/:eType/:kType"} element={<Community />} />
                                <Route path={"/logs/:dType/:eType"} element={<AuditLogs />} />
                                <Route path={"/tasks/:dType"} element={<Tasks />} />
                                <Route path={"/profiles/:dType/:eType"} element={<Profiles />} />
                                <Route path={"/profiles/:dType/:eType/:kType"} element={<Profiles />} />
                                <Route path={"/users"} element={<Users />} />
                                <Route path={"/users/:dType"} element={<Users />} />
                                <Route path={"/billing"} element={<Billing />} />
                                <Route path={"/customers/:dType"} element={<Customers />} />
                                dData?.acnt === 2 ? <Route path={"/insights"} element={<Insights />} /> : <></>
                                {/*dData?.evmSiteId ? <Route path={"/evm"} element={<EVM />} /> : <></>*/}
                                <Route path={"/profile/" + dData?.username} element={<Profile />} />
                                <Route path={"/demo"} element={<Demo />} />
                            </Routes>
                            {/* Interactive help guide. Self-gating: renders null for
                                caregivers, v1 portal, or when no flow qualifies
                                (docs/INTERACTIVE_HELP_PLAN.md §7). Sits inside
                                BrowserRouter but outside <Routes> so the navigation it
                                performs never unmounts it. */}
                            <HelpGuide />
                            <WalkthroughGate />
                        </BrowserRouter>
                    </AlertNotificationProvider>
                );
            }else{
                return (
                    <AlertNotificationProvider>
                        <BrowserRouter>
                            <Routes>
                                <Route path={"/"} element={<Landing />} />
                                <Route path={"/dash/null"} element={<Dashboard />} />
                                <Route path={"/dash/:dType"} element={<Dashboard />} />
                                <Route path={"/alerts/fullscreen/:dType"} element={<Alerts fullscreen={true} />} />
                                <Route path={"/alerts/:dType"} element={<Alerts />} />
                                <Route path={"/alerts"} element={<Alerts />} />
                                <Route path={"/reports/:dType"} element={<Reports />} />
                                <Route path={"/reports/:dType/:eType"} element={<Reports />} />
                                <Route path={"/users"} element={<Users />} />
                                <Route path={"/users/:dType"} element={<Users />} />
                                <Route path={"/profile/" + dData?.username} element={<Profile />} />
                                <Route path={"/demo"} element={<Demo />} />
                            </Routes>
                        </BrowserRouter>
                    </AlertNotificationProvider>
                );
            }
        }else{
            if (window.location.pathname !== "/"){
                return window.location.href = "/";
            }else{
                return (
                    <BrowserRouter>
                        <Routes>
                            <Route path={"/:dType"} element={<Landing />} />
                            <Route path={"/"} element={<Landing />} />
                        </Routes>
                    </BrowserRouter>
                )
            }
        }
    }
};

export default App;
